import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-rt-vertx-code',
	templateUrl:'./VertxCodeSamplesPage.html',
	styles: [],
	styleUrls:['./VertxCodeSamplesPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class VertxCodeSamplesPage
{
	mdContent_1183 = `\`\`\`java
// Publish to all browsers listening on "dashboard"
StompEventBusPublisher.publish(vertx, "dashboard", jsonPayload);

// Or via IGuicedWebSocket (injected)
@Inject IGuicedWebSocket webSocket;
webSocket.broadcastMessage("dashboard", jsonPayload);
\`\`\``;
	mdContent_1184 = `\`\`\`java
public class MyDataReceiver
    implements IWebSocketMessageReceiver<MyResponse, MyDataReceiver> {

    @Override
    public String getMessageDirector() { return "myData"; }

    @Override
    public Uni<MyResponse> receiveMessage(WebSocketMessageReceiver<?> msg) {
        return Uni.createFrom().item(new MyResponse(data));
    }
}
\`\`\``;
	mdContent_1185 = `\`\`\`typescript
// EventBusService is auto-generated and auto-injected
this.eventBusService.listen('dashboard', listenerId)
    .subscribe(data => {
        this.dashboardData = data;
    });
\`\`\``;
}
